import { format } from 'date-fns';

// Leaf module (date-fns only) so both the portal card and the anonymous report page can share it.

// The timestamp comes straight off the wire, where a missing value would otherwise format as the epoch.
export const formatGeneratedAt = (iso: string | null | undefined, pattern: string): string => {
  if (!iso) return '';

  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? '' : format(date, pattern);
};
